import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getActiveTabFromLocalStorage } from "@/ui/TabsComponent/TabsComponent";

import { Page } from "@/ui/Layout/Page";
import { TabsComponent } from "@/ui/TabsComponent";
import Button from "@/ui/Button";
import { ButtonTypes, Variants } from "@/ui/types";
import { DashboardPage } from "@/Apps/Dashboards/DashboardPage";
import { getCampaign } from "@/api/campaigns";
import { Settings } from "@/Apps/Dashboards/Settings/Settings";
import { getSessionToken } from "@/api/auth";
import { PublishCampaignModal } from "../Funnels/Popups/PublishCampaignModal";

import { ContactsGallery } from "@/Apps/CRM/ContactsGallery";
import { getFilterObject } from "@/Apps/CRM/scripts";
import { SessionSchedule } from "./widgets/SessionSchedule";

export const Dashboard = ({ name = "" }) => {
  const [activeTab, setActiveTab] = useState(getActiveTabFromLocalStorage() || "overview");
  const [webinarCampaignData, setWebinarCampaignData] = useState<{
    name?: string;
  }>({ name: "" });
  const [isPublishPopupOpen, setIsPublishPopupOpen] = useState(false);
  // const [activePageId, setActivePageId] = useState(null);
  const { id } = useParams();

  // Fetch the campaign data from the API when the component mounts
  useEffect(() => {
    const token = getSessionToken();

    (async () => {
      const data = await getCampaign({ token, id });
      setWebinarCampaignData(data);
    })();
  }, []);

  // Use this to configure what shows in the top bar of the page
  const topBarSettings = {
    page: [
      { label: name, href: "/webinar" },
      { label: webinarCampaignData.name || "" },
    ],
    items: (
      <Button
        label="Publish Campaign"
        onClick={() => setIsPublishPopupOpen(true)}
        type={ButtonTypes.OUTLINED}
        variant={Variants.INFO}
      />
    ),
  };

  return (
    <Page topBar={topBarSettings}>
      {/* Render the publish campaign modal if it's set to open */}
      {isPublishPopupOpen && (
        <PublishCampaignModal
          setIsOpen={setIsPublishPopupOpen}
          campaignId={id}
          unitName="Webinar Campaign"
        />
      )}
      <div className={`p-6 w-full`}>
        <div className="tabs flex flex-col">
          <TabsComponent
            tabs={[
              { label: "Dashboard", value: "overview" },
              { label: "Scheduling", value: "scheduling" },
              // { label: "Smart Video Builder", value: "builder" },
              { label: "Customize", value: "customize" },
              { label: "Automation", value: "automation" },
              { label: "Activity", value: "crm" },
              { label: "Settings", value: "settings" },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            actionSection={false}
          />
          {activeTab === "overview" && (
            <DashboardPage
              campaignData={webinarCampaignData}
              unitName="webinar"
              panelTitle="Pages in this campaign"
              widgets={[
                {
                  type: "kpi",
                  settings: {
                    items: [
                      { label: "Registration Visits" },
                      { label: "Webinar Registrants" },
                      { label: "Webinar Attendees" },
                      { label: "Replay Attendees" },
                    ],
                  },
                },
                "share",
                "webinarVideo",
                // "webinarCTATime",
              ]}
            />
          )}
          {activeTab === "scheduling" && (
            <DashboardPage
              campaignData={webinarCampaignData}
              unitName="webinar"
              panelTitle="Pages in this campaign"
              widgets={["webinarSchedule"]}
            />
          )}
          {activeTab === "customize" && (
            <DashboardPage
              campaignData={webinarCampaignData}
              unitName="webinar"
              widgets={["webinarCTATime", "customize"]}
            />
          )}
          {activeTab === "automation" && (
            <DashboardPage
              campaignData={webinarCampaignData}
              unitName="webinar"
              widgets={["automation"]}
            />
          )}
          {activeTab === "crm" && (
            <DashboardPage
              campaignData={webinarCampaignData}
              unitName="webinar"
              widgets={["contactList"]}
            />
            // <ContactsGallery
            //   onCreate={() => {}}
            //   defaultFilter={getFilterObject({
            //     field: "hiddenTags",
            //     operator: "contains",
            //     value: id,
            //   })}
            // />
          )}
          {activeTab === "settings" && (
            <Settings
              campaignData={webinarCampaignData}
              setCampaignData={setWebinarCampaignData}
              unitName="Webinar Campaign"
            />
          )}
        </div>
      </div>
    </Page>
  );
};
